import { Navigation, EffectFade, Autoplay, Pagination, Swiper } from 'swiper';
import lazyLoad from './modules/lazy-load';
import { setupUsedForm, submitUsedForm } from './modules/multi-brand-search-used';
import { setupNewForm, submitNewForm } from './modules/multi-brand-search-new';
import { customEvent } from '../modules/tracking/AnalyticsEvents';

const cmsBannersSwiper = new Swiper('.swiper__cms-banners', {
    modules: [Navigation],
    speed: 400,
    spaceBetween: 100,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

const offersSwiper = new Swiper('.swiper__offers', {
    grabCursor: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
    speed: 400,
});

lazyLoad(document.querySelector('.homepage-find-dealer__map'), document.querySelector('#dealer-locator'), function() { return true; });

const homepageSearchBox = document.querySelector('.homepage-hero__search-box');
const newOrUsed = homepageSearchBox.querySelector('select[name="new_or_used"]');
const homepageSearchBoxSubmitButton = homepageSearchBox.querySelector('.btn--primary');
if (newOrUsed) {
    setupUsedForm(homepageSearchBox);
    const newFormMakeChangeCallback = setupNewForm(homepageSearchBox);

    const handleNewOrUsedChangeEvent = function () {
        if (newOrUsed.value == 'used') {
            homepageSearchBoxSubmitButton.removeAttribute('disabled');
        }
        // Toggle visible fields based on new or used selected
        homepageSearchBox.querySelectorAll('[data-homepage-hero-field]').forEach(field => {
            if (newOrUsed.value == '') {
                return;
            }
            field.style.display = (field.dataset.homepageHeroField == newOrUsed.value) ? 'block' : 'none';
        });
        newFormMakeChangeCallback();
    }
    newOrUsed.addEventListener('change', handleNewOrUsedChangeEvent);
    handleNewOrUsedChangeEvent();

    homepageSearchBoxSubmitButton.addEventListener('click', function (event) {
        if (newOrUsed.value == 'used') {
            submitUsedForm(homepageSearchBox);
        } else if (newOrUsed.value == 'new') {
            submitNewForm(homepageSearchBox);
        }
    });
}

const homepageHeroForeground = new Swiper('.hero-bg-swiper', {
    modules: [Navigation, EffectFade, Pagination, Autoplay],
    navigation: {
        nextEl: '.homepage-swiper-button--next',
        prevEl: '.homepage-swiper-button--prev',
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    followFinger: false,
    grapCursor: false,
    allowTouchMove: false,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
    },
    allowTouchMove: true,
    breakpoints: {
        1280: {
            allowTouchMove: false,
        }
    },
    // autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: false,
    //     waitForTransition: true,
    // },
});

if (document.querySelector(".configurator-content-side-by-side__slider")) {
    const firstImage = document.querySelector("[data-split-foreground]");
    const secondImage = document.querySelector("[data-split-background]");
    const sliderButton = document.querySelector(".configurator-content-side-by-side__slider--button");
    const sliderLine = document.querySelector(".configurator-content-side-by-side__slider--line");
    const interaction = false;
    document.querySelector(".configurator-content-side-by-side__slider").addEventListener("input", (event) => {
        if (!interaction) {
            customEvent('New Model Search', 'Configurator Image Slider', 'Interacted')
        }
        const sliderPos = event.target.value;

        secondImage.style.setProperty("--width", sliderPos + "%");
        secondImage.style.clipPath =
            "polygon(0% 0%," + sliderPos + "% 0%," + sliderPos + "% 100%,0% 100%)";
        sliderButton.style.setProperty("left", "calc(" + sliderPos + "% - 25px)");
        sliderLine.style.setProperty("left", "calc(" + sliderPos + "% - 5px)");
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/homepages/multi-brand.js